module.exports = __webpack_public_path__ + "media/frontend/components/library/images/empty-21d36e633adcde8504a7ddefaec69d68.png";